<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lxgp1">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
        <img :src="images.lxgp2">
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">连续钢坯铸造机组</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">
          本公司提供各种连续铸造机组，可生产
          <span style="color:#333333;">方坯和板坯。</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lxgp1: require("../../../assets/img/common/lxgp1.jpg"),
        lxgp2: require("../../../assets/img/common/lxgp2.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/lxgp.vue